import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigConsumer from '../ConfigConsumer';
import FormContext from '../tools/FormContext';
export default function Checkbox(_ref) {
  var className = _ref.className,
      _onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      size = _ref.size,
      indeterminate = _ref.indeterminate,
      uncheckable = _ref.uncheckable,
      id = _ref.id;
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    context: FormContext,
    checked: checked,
    disabled: disabled
  }, function (_ref2) {
    var configChecked = _ref2.checked,
        configDisabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement(ConfigConsumer, {
      size: size
    }, function (_ref3) {
      var configSize = _ref3.size;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: classNames('jmtd-checkbox', className, {
          'jmtd-checkbox-large': configSize === 'large',
          'jmtd-checkbox-small': configSize === 'small',
          'jmtd-checkbox-mini': configSize === 'mini',
          'jmtd-checkbox-indeterminate': indeterminate,
          'jmtd-checkbox-checked': configChecked && !indeterminate,
          'jmtd-checkbox-disabled': configDisabled,
          'jmtd-checkbox-uncheckable': uncheckable
        })
      }, /*#__PURE__*/React.createElement("input", {
        className: "jmtd-checkbox-input",
        onChange: function onChange() {
          _onChange(!configChecked);
        },
        type: "checkbox",
        disabled: configDisabled || uncheckable,
        checked: configChecked || false
      }), /*#__PURE__*/React.createElement("span", {
        className: "jmtd-checkbox-inner"
      }));
    });
  });
}
Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  uncheckable: PropTypes.bool
};
Checkbox.defaultProps = {
  id: null,
  checked: null,
  onChange: function onChange() {},
  className: '',
  disabled: null,
  size: null,
  indeterminate: null,
  uncheckable: null
};